import { combineReducers } from 'redux'
import user from './user'
import dictionary from './dictionary'
import snackbar from './snackbar'
import popup from './popup'

const rootReducer = combineReducers({
  user,
  dictionary,
  snackbar,
  popup
})

export default rootReducer